import type { ChatMessage } from '@/features/chat/chatSlice';

const API_URL = import.meta.env.VITE_LOCAL === 'true' ? import.meta.env.VITE_API_URL_DEV : import.meta.env.VITE_API_URL;
export async function sendMessage(chatId: string, text: string): Promise<ChatMessage> {
  console.log('API_URL: ', API_URL);
  console.log('Sending message:', { chatId, text });
  const response = await fetch(`${API_URL}/chat`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ chatId, prompt: text }),
  });
  if (!response.ok) {
    throw new Error(`Failed to send message: ${response.statusText}`);
  }

  const aiMessage = (await response.json()) as ChatMessage;
  console.log('AI Message:', aiMessage);
  aiMessage.id = crypto.randomUUID();
  return aiMessage;
}
